import { render, staticRenderFns } from "./Van.vue?vue&type=template&id=7c2bd8bb&"
import script from "./Van.vue?vue&type=script&lang=js&"
export * from "./Van.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports